import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { environment } from '@env/environment';

@Component({
  selector: 'app-tp-watermark',
  standalone: true,
  imports: [CommonModule],
  template: `<div class="watermark">{{ environmentName }}</div>`,
  styleUrl: './tp-watermark.component.scss',
})
export class TpWatermarkComponent {
  protected environmentName!: string;

  constructor() {
    this.environmentName = environment.alias;
  }
}
